import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import ListWrapper from '../ListWrapper'
import TableWrapper from '../TableWrapper'
import CollapsibleWrapper from '../CollapsibleWrapper'

const useStyles = makeStyles((theme) => ({

}))

const FromF10Section = (props) => {
  const { studentInfos, universityList, } = props
  const { t } = useTranslation('student_profile')

  return (
    <React.Fragment>
      <ListWrapper
        title={t(`Study result`)}
        data={studentInfos}
        fields={[
          { name: 'university_id', options: universityList, },
          { name: 'study_major', },
          { name: 'extra_data.entrance_score', },
          { name: 'extra_data.university.gpa', },
        ]}
        t={t}
      />

      <CollapsibleWrapper title={t(`extra_data.achievements`)}>
        <TableWrapper
          data={studentInfos}
          tableName='extra_data.achievements'
          fields={[
            { name: 'name', align: 'left', },
            { name: 'description', align: 'right', },
          ]}
          t={t}
        />
      </CollapsibleWrapper>

      <CollapsibleWrapper title={t(`extra_data.experience_info.volunteer_experiences`)}>
        <TableWrapper
          data={studentInfos}
          tableName='extra_data.experience_info.volunteer_experiences'
          fields={[
            { name: 'title', align: 'left', },
            { name: 'description', align: 'left', },
          ]}
          t={t}
        />
      </CollapsibleWrapper>

      <CollapsibleWrapper title={t(`extra_data.experience_info.work_experiences`)}>
        <TableWrapper
          data={studentInfos}
          tableName='extra_data.experience_info.work_experiences'
          fields={[
            { name: 'position', align: 'left', },
            { name: 'description', align: 'left', },
            { name: 'work_place', align: 'left', },
            { name: 'weekly_hours', align: 'left', },
          ]}
          t={t}
        />
      </CollapsibleWrapper>
    </React.Fragment>
  )
}

export default FromF10Section